export default __webpack_public_path__ + "static/media/json.e08f40f1.webp";